<template>
	<v-container fluid class="pt-0 pb-0">
		<DialogFiltros
			:dialog="dialogFiltro"
			@dialogClose="dialogFiltroClose"
			:marcas="marcas"
			:grupos="grupos"
			:subgrupos="subgrupos"
		/>
		<v-row justify="center">
			<v-col cols="2" class="d-none d-md-flex pt-0" v-if="empresa.filtrar && !retornarModoDelivery()">
				<v-row class="mb-2">
					<v-col cols="12" class="pr-1 pa-0 mt-0">
						<Filtros :marcas="marcas" :grupos="grupos" :subgrupos="subgrupos" />
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="10" class="pt-0">
				<v-row class="mb-">
					<v-col cols="10" sm="10" md="11" class="pr-1 pt-0">
						<v-text-field
							label="Pesquisar um produto"
							v-model="pesquisa"
							filled
							rounded
							class="pr-0 textField"
							append-icon="mdi-close"
							@click:append="limparPesquisa()"
							@keypress.enter="search()"
							hide-details
						>
						</v-text-field>
					</v-col>
					<v-col cols="1" sm="2" md="1" class="pl-1 pt-0">
						<v-btn @click="search()" color="primary" block height="100%" class="textField">
							<v-icon> mdi-magnify </v-icon>
						</v-btn>
					</v-col>
				</v-row>
				<v-row justify="center" class="d-flex d-md-none mb-5" v-if="!retornarModoDelivery()">
					<v-btn text @click="abrirFiltrosOpen()">
						<v-icon>mdi-tune</v-icon>
						Filtrar
					</v-btn>
				</v-row>

				<v-row
					justify="center"
					v-if="!this.$route.query.grupo && retornarModoDelivery() && !this.$route.query.search"
				>
					<template v-for="grupo in this.grupos.itens">
						<v-col :key="grupo.nome" class="pt-0">
							<GrupoCard :grupo="grupo" />
						</v-col>
					</template>
				</v-row>
				<v-row justify="center" v-else>
					<v-col cols="12" v-if="retornarModoDelivery() && this.$route.query.grupo" class="grupo pt-0 label">
						<v-icon @click="voltarGrupos" color="texto">mdi-arrow-left</v-icon>
						{{ this.$route.query.grupo }}
					</v-col>
					<template v-for="item in this.itens">
						<v-col :key="item.id" class="pt-0">
							<Produto :item="item" />
						</v-col>
					</template>
				</v-row>
				<div v-if="this.itens.length == 0" class="mensagem-itens">Nenhum produto foi encontrado!</div>
				<v-row justify="center" v-if="!retornarModoDelivery() || this.$route.query.grupo">
					<v-pagination v-model="pagina" :length="qtdPaginas" :total-visible="5" color="primary" class="pagina"/>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import Produto from '../Produto/ProdutoCard.vue'
import { mapGetters } from 'vuex'
import Filtros from './Filtros.vue'
import DialogFiltros from './DialogFiltros.vue'
import GrupoCard from '../Produto/GrupoCard.vue'

export default {
	components: { Produto, Filtros, DialogFiltros, GrupoCard },
	data: function () {
		return {
			loading: false,
			itensPorPagina: 12,
			pagina: 1,
			pesquisa: this.$route.query.search ? this.$route.query.search : '',
			dialogFiltro: false,
		}
	},
	methods: {
		click(item) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							marca: item,
							pagina: 1,
						}
					),
				},
				() => {}
			)
		},
		clickPagina(item) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							pagina: item,
						}
					),
				},
				() => {}
			)
		},
		search() {
			let query = {}

			if (this.$route.query.grupo && this.retornarModoDelivery())
				query = { grupo: this.$route.query.grupo, search: this.pesquisa, pagina: 1 }
			else query = { search: this.pesquisa, pagina: 1 }
			this.$router.replace({ query: Object.assign({ ...this.$router.query }, query) }, () => {})
		},
		limparPesquisa() {
			this.pesquisa = ''
			this.search()
		},

		abrirFiltrosOpen() {
			this.dialogFiltro = true
		},
		dialogFiltroClose() {
			this.dialogFiltro = false
		},
		voltarGrupos() {
			this.$router.push(`/${this.catalogo.identificadorCatalogo}${this.retornarQueryVendedor()}`)
		},
	},
	computed: {
		qtdPaginas() {
			return Math.ceil(this.total / this.itensPorPagina)
		},
		...mapGetters(['catalogo', 'empresa', 'itens', 'marcas', 'grupos', 'subgrupos', 'total']),
	},
	mounted() {
		if (this.$route.query.pagina == 'NaN' || !this.$route.query.pagina) this.$route.query.pagina = 1

		if (this.pagina != this.$route.query.pagina) {
			this.pagina = parseInt(this.$route.query.pagina)
		}
	},
	watch: {
		pagina() {
			this.$router.replace(
				{
					query: Object.assign({ ...this.$route.query }, { pagina: this.pagina }),
				},
				() => {}
			)
		},
	},
}
</script>
<style scoped>
.textField {
	border-radius: 1rem;
}

.textField >>> .v-text-field__slot input {
    color: var(--v-texto-base);
}

.grupo {
	font-weight: 900;
	font-size: 20px;
	text-transform: uppercase;
	display: flex;
	gap: 1rem;
}

.mensagem-itens {
	text-align: center;
	margin-bottom: 0.5rem;
}

.textField >>> .theme--light.v-icon.mdi-close {
    color: var(--v-texto-base);
}

.pagina >>> .theme--light.v-pagination .v-pagination__item--active {
    color: var(--v-textoBotoes-base);;
}

.label{
	color: var(--v-texto-base);
}
</style>
